import { render, staticRenderFns } from "./ProductEditLabelsStockLocation.vue?vue&type=template&id=5478c12e"
import script from "./ProductEditLabelsStockLocation.vue?vue&type=script&lang=ts"
export * from "./ProductEditLabelsStockLocation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports